import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { ConfigService } from '../../../config/config.service';

@Injectable()
export class ConvertTaskFileIntoTaskInternalFileService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public convert(taskFileId: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/task-files/${taskFileId}/convert-into-task-internal-file`;

    return this.client.post<any>(url, {})
    .pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}